// ─── WHAT-IF SIMULATOR SUGGESTIONS ──────────────────────────────────────────
// Source: Section 5 — Post-Assessment Engagement: "What If" Improvement Simulator
// Each suggestion maps an original answer to a better value and shows impact.

export const SIMULATOR_SUGGESTIONS = [
  {
    id: "sim_q1",
    qId: "Q1",
    domain: 1,
    triggerValues: ["manual", "email"],
    suggestionLabel: "Dedicated election system",
    newValue: "dedicated",
    impactPts: "+8 pts",
    impactDetail: "Saves 18–25 hrs/week in coordination overhead",
    product: "Poll Worker Management",
  },
  {
    id: "sim_q1b",
    qId: "Q1b",
    domain: 1,
    triggerValues: ["frequent", "occasional"],
    suggestionLabel: "Eliminate version conflicts",
    newValue: "never",
    impactPts: "+4 pts",
    impactDetail: "Eliminates election-day coordination failures",
    product: "Poll Worker Management",
  },
  {
    id: "sim_q4",
    qId: "Q4",
    domain: 2,
    triggerValues: ["paper", "spreadsheet"],
    suggestionLabel: "Real-time asset tracking system",
    newValue: "realtime",
    impactPts: "+12 pts",
    impactDetail: "Eliminates equipment loss and L&A testing gaps",
    product: "Election Asset Management",
  },
  {
    id: "sim_q5",
    qId: "Q5",
    domain: 2,
    triggerValues: ["manual_check", "email_remind"],
    suggestionLabel: "Automated L&A tracking",
    newValue: "automated",
    impactPts: "+5 pts",
    impactDetail: "Prevents equipment arriving without testing certification",
    product: "Election Asset Management",
  },
  {
    id: "sim_q8",
    qId: "Q8",
    domain: 3,
    triggerValues: ["over_week", "2to5days"],
    suggestionLabel: "AI-powered legal response (< 1 hr)",
    newValue: "under1hr",
    impactPts: "+5 pts",
    impactDetail: "Prevents compliance delays and decision paralysis",
    product: "Policy AI",
  },
  {
    id: "sim_q10",
    qId: "Q10",
    domain: 4,
    triggerValues: ["phone", "email_chains"],
    suggestionLabel: "Dedicated ticketing system",
    newValue: "ticketing",
    impactPts: "+5 pts",
    impactDetail: "Closes the gap on issues falling through the cracks",
    product: "Support IQ",
  },
  {
    id: "sim_q12",
    qId: "Q12",
    domain: 5,
    triggerValues: ["none", "manual"],
    suggestionLabel: "Integrated analytics platform",
    newValue: "integrated",
    impactPts: "+5 pts",
    impactDetail: "Real-time visibility into voter data and performance",
    product: "Analytics Hub",
  },
  {
    id: "sim_q21",
    qId: "Q21",
    domain: 6,
    triggerValues: ["manual", "email_dig"],
    suggestionLabel: "Fully automated absentee intake",
    newValue: "automated",
    impactPts: "+5 pts",
    impactDetail: "Reduces processing time by 40–70%, eliminates data entry errors",
    product: "Absentee Ballot Portal",
  },
  {
    id: "sim_q22",
    qId: "Q22",
    domain: 6,
    triggerValues: ["manual_verify", "sep_systems"],
    suggestionLabel: "Auto-verification via integrated system",
    newValue: "auto_verify",
    impactPts: "+5 pts",
    impactDetail: "Instant voter record matching, eliminates manual bottleneck",
    product: "Absentee Ballot Portal",
  },
  {
    id: "sim_q23",
    qId: "Q23",
    domain: 6,
    triggerValues: ["multi_days", "next_day"],
    suggestionLabel: "Real-time status reporting",
    newValue: "realtime",
    impactPts: "+6 pts",
    impactDetail: "Full real-time visibility — eliminates backlog blindspots",
    product: "Absentee Ballot Portal",
  },
  {
    id: "sim_q25",
    qId: "Q25",
    domain: 7,
    triggerValues: ["none", "manual", "static"],
    suggestionLabel: "Real-Time Voter Guidance",
    newValue: "realtime",
    impactPts: "+5 pts",
    impactDetail: "Automates 80% of routine voter inquiries",
    product: "Voter AI",
  },
  {
    id: "sim_q26",
    qId: "Q26",
    domain: 7,
    triggerValues: ["no_capacity", "email", "call_center"],
    suggestionLabel: "AI-Powered Automated Response",
    newValue: "ai_auto",
    impactPts: "+5 pts",
    impactDetail: "Handles high-volume peaks without adding staff",
    product: "Voter AI",
  },
];

// ─── OPTIMIZATION TEMPLATES ───────────────────────────────────────────────
// Pre-set improvement paths — common improvement bundles
export const OPTIMIZATION_TEMPLATES = [
  {
    id: "absentee_first",
    label: "Absentee Ballot Priority",
    description: "Focus on compliance and legal risk reduction",
    suggestionIds: ["sim_q21", "sim_q22", "sim_q23"],
    estimatedGain: "+16–18 pts",
  },
  {
    id: "operations_boost",
    label: "Operational Efficiency Boost",
    description: "Tackle coordination and asset management",
    suggestionIds: ["sim_q1", "sim_q4", "sim_q5"],
    estimatedGain: "+20–25 pts",
  },
  {
    id: "full_overhaul",
    label: "Full Readiness Overhaul",
    description: "Apply all available improvements",
    suggestionIds: ["sim_q1", "sim_q4", "sim_q8", "sim_q10", "sim_q21", "sim_q22", "sim_q23", "sim_q25", "sim_q26"],
    estimatedGain: "+40–50 pts",
  },
];
